module.exports = __webpack_public_path__ + "img/money.ba179f8a.jpg";